import { MutationTree } from 'vuex';
import { DocumentsState } from '../stores/documents.store';
import { ITag } from '@/types/Tag';

export const mutationIsLoadingTags = 'setIsLoadingTags';
export const mutationSetTags = 'setTags';

export const mutations: MutationTree<DocumentsState> = {
  [mutationIsLoadingTags](state, payload: boolean) {
    state.isLoadingTags = payload;
  },
  [mutationSetTags](state, payload: ITag[]) {
    state.tags = payload;
  },
};
